import React, {useEffect, useState} from 'react'
import { useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import PropTypes from 'prop-types';
import ActionDialogCourse from './ActionDialogCourse';


function ShowCourse (props)  {
  const {
    schoolYears
  } = props;
  const endpoint = 'http://127.0.0.1:8000/api';
  const [schoolYear, setSchoolYear] = useState([]);

  const listCourse = useSelector(state => state.course);
    const [rowDataState, setRowDataState] = useState([]);
    const [statusButton, setStatusButton] = React.useState(false);

      const [tableColumns, setTableColumns] = useState([]);
      const [tableList, setTableList] = useState([]);
      
      const columns = [
        {
          name: 'id',
          options: {
            filter: false,
            display: false,
          }
        },
        {
          label: 'Nombre',
          name: 'name',
          options: {
            filter: true,
          }
        },
        {
          label: 'Descripción',
          name: 'description',
          options: {
            filter: true,
          }
        },
        {
          label: 'Año Lectivo',
          name: 'school_year_id',
          options: {
            filter: true,
            customBodyRender: (value) => {
              const item = value;
              let nameItem = '';
              schoolYear.map((option) => {
                if (option.id === item) {
                  nameItem = option.year;
                }
                return nameItem;
              });
              return nameItem;
            },
          }
        },
        {
          name: 'school_year_id',
          options: {
            filter: false,
            display: false,
          }
        },
        {
            label: 'Estado',
            name: 'status',
            options: {
              filter: true,
              customBodyRender: (value) => {
                if(value === 'Activo'){
                  return 'Activo';
                }
                  return 'Removido';
                }
              }
          },
      ];

     /**
 * Method to set the documents list and tabe columns
 */
  useEffect(() => {
    if (listCourse && listCourse.length >= 0) {
      setTableList(listCourse);
      if (tableColumns.length === 0 && schoolYear.length !== 0  && schoolYear.length !== undefined)  {
        setTableColumns(columns);
      }
    }
  }, [listCourse, schoolYears]);

  

  /**
  * Method to set the list pricing plans
  */
  const getAllSchoolYear = async() => {
    const response = await axios.get(endpoint+'/school-year');
    setSchoolYear(response.data);
  };

  /**
   * Retrieve pricing plan list
   */
  useEffect(() => {
    getAllSchoolYear();  
  }, []);
  
    
  
      /**
       * Method to recoer the specifid values of the row
       * @param {rowData} rowData
       */
      const handleRowData = (rowData) => {
        const rowDataTemp = [];
        rowDataTemp.length = 0;
        rowDataTemp.push(rowData[0]);
        rowDataTemp.push(rowData[1]);
        rowDataTemp.push(rowData[2]);
        rowDataTemp.push(rowData[3]);
        rowDataTemp.push(rowData[4]);
        rowDataTemp.push(rowData[5]);
        setRowDataState(rowDataTemp);   
      };
    
      const handleCloseButton = () => {
        setStatusButton(false);
      };
    
      const options = {
        selectableRowsHideCheckboxes: true,
        selectableRows: 'single',
        filterType: 'dropdown',
        responsive: 'standard',
        print: true,
        selectableRowsOnClick: false,
        rowsPerPage: 10,
        downloadOptions: {
          filename: 'lp',
          filterOptions: {
            useDisplayedRowsOnly: true,
          }
        },
        onDownload: (buildHead, buildBody, columnsData, data) => {
          const val = '\uFEFF' + `${buildHead(columnsData)}${buildBody(data)}`.trim();
          return val;
        },
        onRowClick: (rowData) => {          
          handleRowData(rowData);
          setStatusButton(true);
        }
      };
    
      return (
        <div>
        <div>
          <MUIDataTable
            title='Cursos'
            data={tableList}
            columns={tableColumns}
            options={options}
          />
          <ActionDialogCourse openStatus={statusButton} onClosed= {handleCloseButton} rowData={rowDataState} schoolYear={schoolYear}/>
        </div>
        </div>
      );
}

ShowCourse.propTypes = {
  teachers: PropTypes.array,
};

ShowCourse.defaultProps = {
  teachers: []
};

export default ShowCourse